export interface BirthdayPerson {
  id: number;
  name: string;
  email: string;
  /** true si el cumpleañero es el propio usuario de la sesión. */
  self: boolean;
}

export function isLeapYear(year: number): boolean {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

/**
 * Día en que se celebra el cumpleaños dentro de `year` (YYYY-MM-DD). Los nacidos
 * un 29 de febrero lo celebran el 28 en los años no bisiestos.
 */
export function birthdayDateInYear(birthYmd: string, year: number): string {
  const monthDay = birthYmd.slice(5, 10);
  if (monthDay === '02-29' && !isLeapYear(year)) return `${year}-02-28`;
  return `${year}-${monthDay}`;
}

export function birthdayDisplayName(p: BirthdayPerson): string {
  return p.name.trim() || p.email.split('@')[0];
}

export function birthdayFirstName(p: BirthdayPerson): string {
  return birthdayDisplayName(p).split(' ')[0];
}

/** "Ana", "Ana y Luis", "Ana, Luis y Mar". */
function joinNames(names: string[]): string {
  if (names.length <= 1) return names[0] || '';
  return `${names.slice(0, -1).join(', ')} y ${names[names.length - 1]}`;
}

/** Mensaje para los compañeros del cumpleañero (no incluye al propio usuario). */
export function birthdayMessage(people: BirthdayPerson[]): string {
  if (people.length === 0) return '';
  const names = joinNames(people.map(birthdayDisplayName));
  return people.length === 1
    ? `Hoy es el cumpleaños de ${names}. ¡No olvides felicitarle!`
    : `Hoy es el cumpleaños de ${names}. ¡No olvides felicitarles!`;
}

/** Mensaje que ve el cumpleañero. */
export function ownBirthdayMessage(p: BirthdayPerson): string {
  return `¡Feliz cumpleaños, ${birthdayFirstName(p)}! Todo el equipo te desea un gran día.`;
}
